import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  push,
  update,
  remove,
  onValue,
} from "firebase/database";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  signInAnonymously,
} from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCPsPJbDoTGLw1sWwzjC2G03COD3c2Mz5Q",
  authDomain: "putri-henna.firebaseapp.com",
  databaseURL:
    "https://putri-henna-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "putri-henna",
  storageBucket: "putri-henna.firebasestorage.app",
  messagingSenderId: "167568256964",
  appId: "1:167568256964:web:c0d8f9bce9550a4e16be91",
  measurementId: "G-NZS2M4HVCP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

// Authorized admin emails
const ADMIN_EMAILS = [
  "putrileony.office@gmail.com",
  "defuj.dev@gmail.com",
  // Add more authorized emails here
];

// Gallery CRUD operations
export const subscribeToGallery = (callback) => {
  const galleryRef = ref(db, "gallery");
  return onValue(galleryRef, (snapshot) => {
    const data = snapshot.val();
    const galleryList = data
      ? Object.entries(data).map(([key, value]) => ({
          ...value,
          id: key,
        }))
      : [];
    callback(galleryList);
  });
};

export const addGalleryItem = async (item) => {
  const galleryRef = ref(db, "gallery");
  const newItem = {
    ...item,
    createdAt: Date.now(),
  };
  await push(galleryRef, newItem);
  return newItem;
};

export const updateGalleryItem = async (id, item) => {
  const itemRef = ref(db, `gallery/${id}`);
  await update(itemRef, item);
};

export const deleteGalleryItem = async (id) => {
  const itemRef = ref(db, `gallery/${id}`);
  await remove(itemRef);
};

// Testimonials CRUD operations
export const subscribeToTestimonials = (callback, includePending = false) => {
  const testimonialsRef = ref(db, "testimonials");
  return onValue(testimonialsRef, (snapshot) => {
    const data = snapshot.val();
    const testimonialsList = data
      ? Object.entries(data).map(([key, value]) => ({
          ...value,
          id: key,
        }))
      : [];

    // Filter based on approval status
    const filteredList = includePending
      ? testimonialsList
      : testimonialsList.filter((t) => t.approved === true);

    // Sort by createdAt descending
    filteredList.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

    callback(filteredList);
  });
};

export const addTestimonial = async (testimonial) => {
  const testimonialsRef = ref(db, "testimonials");
  const newTestimonial = {
    ...testimonial,
    approved: false, // Default to pending approval
    createdAt: Date.now(),
  };
  await push(testimonialsRef, newTestimonial);
  return newTestimonial;
};

export const updateTestimonial = async (id, testimonial) => {
  const testimonialRef = ref(db, `testimonials/${id}`);
  await update(testimonialRef, testimonial);
};

export const approveTestimonial = async (id, approved) => {
  const testimonialRef = ref(db, `testimonials/${id}`);
  await update(testimonialRef, { approved });
};

export const deleteTestimonial = async (id) => {
  const testimonialRef = ref(db, `testimonials/${id}`);
  await remove(testimonialRef);
};

// Authentication functions
export const loginWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user;
};

export const logout = async () => {
  await signOut(auth);
};

export const signInAnonymouslyForPublicForm = async () => {
  try {
    const result = await signInAnonymously(auth);
    return result.user;
  } catch (error) {
    console.error("Error signing in anonymously:", error);
    throw error;
  }
};

export const onAuthStateChange = (callback) => {
  return auth.onAuthStateChanged(callback);
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

// Authorization check
export const isAdminUser = (user) => {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.includes(user.email);
};

// Export auth and db for direct access if needed
export { auth, db };

// Export app instance
export default app;
